import { isRecord } from '@cascade/core/utils';
import * as projects from '@cascade/react/projects';
import type { THelpdeskIdsByProject } from '@cascade/react/projects';
import { useState } from 'react';
import type { TProjectsProviderProps } from './Projects.types.ts';
import {
  readStorageItem,
  updateStorageItem,
  writeStorageItem,
} from '#utils/storage/index.ts';

const CURRENT_PROJECT_KEY = 'cascade.projects.current';
const CURRENT_HELPDESKS_KEY = 'cascade.projects.helpdesks';

const readHelpdeskIds = (): THelpdeskIdsByProject => {
  const stored = readStorageItem(CURRENT_HELPDESKS_KEY, { isJson: true });

  return isRecord(stored) ? (stored as THelpdeskIdsByProject) : {};
};

const rememberProject = (projectId?: string) =>
  updateStorageItem(CURRENT_PROJECT_KEY, projectId);

const rememberHelpdeskIds = (helpdeskIds: THelpdeskIdsByProject) =>
  writeStorageItem(CURRENT_HELPDESKS_KEY, helpdeskIds, { isJson: true });

export const ProjectsProvider = ({
  scope,
  requestedProjectId,
  requestedHelpdeskId,
  children,
}: TProjectsProviderProps) => {
  const [previousProjectId] = useState(() =>
    readStorageItem(CURRENT_PROJECT_KEY),
  );

  const [previousHelpdeskIds] = useState(readHelpdeskIds);

  return (
    <projects.ProjectsProvider
      scope={scope}
      requestedProjectId={requestedProjectId}
      previousProjectId={previousProjectId}
      requestedHelpdeskId={requestedHelpdeskId}
      previousHelpdeskIds={previousHelpdeskIds}
      onProjectChange={rememberProject}
      onHelpdeskIdsChange={rememberHelpdeskIds}
    >
      {children}
    </projects.ProjectsProvider>
  );
};
